import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";

export default function Profile() {
  const [profile, setProfile] = useState({
    visi: "",
    misi: [],
    sejarah: { deskripsi: "", foto: [] },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const mainSnap = await getDoc(doc(db, "profilSekolah", "main"));
        const mainData = mainSnap.exists()
          ? mainSnap.data()
          : { visi: "", misi: [] };

        const sejarahSnap = await getDoc(doc(db, "profilSekolah", "sejarah"));
        const sejarahData = sejarahSnap.exists()
          ? sejarahSnap.data()
          : { deskripsi: "", foto: [] };

        const formattedFoto = Array.isArray(sejarahData.foto)
          ? sejarahData.foto.map((f) =>
              typeof f === "string"
                ? { url: f, judul: "", teks: "" }
                : f
            )
          : [];

        setProfile({
          visi: mainData.visi || "",
          misi: mainData.misi || [],
          sejarah: { ...sejarahData, foto: formattedFoto },
        });
      } catch (err) {
        console.error("fetch profile error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading)
    return <p className="text-center mt-5">Memuat Profil Sekolah...</p>;

  return (
    <section
      className="profile-section py-5"
      style={{
        background: `
          linear-gradient(
            to bottom,
            #F5F7FA 0%,
            #E3F2FD 35%,
            #E8F5E9 65%,
            #FFFFFF 100%
          )
        `,
      }}
    >
      <div className="container">
        {/* Judul */}
        <h2
          className="text-center fw-bold mb-5 display-6"
          style={{ color: "#0D47A1" }}
        >
          Profil Sekolah
        </h2>

        {/* ================= SEJARAH ================= */}
        {profile.sejarah?.deskripsi && (
          <div className="mb-5 row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <h4 className="mb-3" style={{ color: "#1B5E20" }}>
                Sejarah Sekolah
              </h4>

              <div
                className="p-4 shadow-sm rounded"
                style={{
                  backgroundColor: "#FFFFFF",
                  lineHeight: "1.8",
                  borderLeft: "5px solid #1B5E20",
                }}
              >
                <p className="mb-0" style={{ textAlign: "justify" }}>
                  {profile.sejarah.deskripsi}
                </p>
              </div>
            </div>

            {profile.sejarah.foto?.length > 0 && (
              <div className="col-md-6 d-flex flex-wrap gap-3">
                {profile.sejarah.foto.map((foto, i) => (
                  <motion.img
                    key={i}
                    src={foto.url}
                    alt={foto.judul || `Sejarah ${i + 1}`}
                    className="img-fluid rounded shadow-sm"
                    style={{
                      objectFit: "cover",
                      height: 280,
                      width: "100%",
                    }}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: i * 0.2 }}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {/* ================= VISI ================= */}
        {profile.visi && (
          <motion.div
            className="mb-5 text-center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h4 className="mb-3" style={{ color: "#0D47A1" }}>
              Visi
            </h4>

            <div
              className="p-4 shadow-sm rounded mx-auto"
              style={{
                backgroundColor: "#FFFFFF",
                maxWidth: 800,
                borderTop: "4px solid #0D47A1",
              }}
            >
              <p className="fst-italic mb-0">{profile.visi}</p>
            </div>
          </motion.div>
        )}

        {/* ================= MISI ================= */}
        {profile.misi && profile.misi.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h4
              className="mb-4 text-center"
              style={{ color: "#0D47A1" }}
            >
              Misi Kami
            </h4>

            <div className="row justify-content-center">
              {profile.misi.map((m, i) => (
                <motion.div
                  key={i}
                  className="col-md-5 mb-3"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.15 }}
                >
                  <div
                    className="p-3 rounded d-flex align-items-start shadow-sm"
                    style={{
                      background: "#FFFFFF",
                      borderLeft: "4px solid #0D47A1",
                    }}
                  >
                    <FaCheckCircle
                      className="me-2 mt-1"
                      style={{ color: "#1B5E20" }}
                    />
                    <span>{m}</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
}
